import React from 'react'
import PropTypes from 'prop-types'
import { Form as CaptchaForm } from '../../Captcha'
import { Field } from '../../../Components/Form'

export class Form extends React.Component {

  static propTypes = {
    onLogin:      PropTypes.func.isRequired,
    isProcessing: PropTypes.bool,
    userDefaults: PropTypes.object,
    dictionary:   PropTypes.object.isRequired,
  }

  static defaultProps = {
    userDefaults: {},
  }

  state = {
    fields: {
      username: {
        isValid: false,
        isFocused: false,
        isEdited: false,
        value: '',
      },
      password: {
        isValid: false,
        isFocused: false,
        isEdited: false,
        value: '',
      },
    },
  }

  onChange = field => (
    event => {
      const { value } = event.target

      this.setFieldState(field, {
        value:   value,
        isValid: !!value,
      })
    }
  )

  onBlur = field => {
    return () => this.setFieldState(field, {
      isFocused: false,
    })
  }

  onFocus = field => {
    return () => this.setFieldState(field, {
      isFocused: true,
      isEdited: true,
    })
  }

  showError = field => {
    const {
      isValid,
      isFocused,
      isEdited
    } = this.getField(field)

    return !isFocused && !isValid && isEdited;
  }

  /**
   * Captcha resolved, submit form.
   */
  onResolved = response => {
    const values = Object.entries(this.state.fields)
        .reduce((obj, [field, {value}]) => (
          Object.assign(obj, {[field]: value })
        ), {})

    this.props.onLogin({
      ...this.props.userDefaults,
      ...values,
      'g-recaptcha-response': response,
    })
  }

  getField = field => this.state.fields[field]

  setFieldState = (field, props) => {
    this.setState({
      fields: {
        ...this.state.fields,
        [field]: {
          ...this.getField(field),
          ...props,
        }
      }
    })
  }

  /**
   * Submit button is enabled.
   */
  get isEnabled() {
    return !this.props.isProcessing &&
      (this.isValid || this.isFocused)
  }

  /**
   * All fiels are valid.
   */
  get isValid() {
    return Object.entries(this.state.fields)
      .reduce((acc, [key, {isValid}]) => acc && isValid, true);
  }

  /**
   * A field has focus.
   */
  get isFocused() {
    return Object.entries(this.state.fields)
      .reduce((acc, [key, {isFocused}]) => acc || isFocused, false);
  }

  render() {
    const { dictionary, isProcessing } = this.props;
    const buttonClass = isProcessing
      ? 'btn login-btn-email btn-disabled'
      : 'btn login-btn-email';
    const formClass = isProcessing
      ? 'loginform-processing'
      : '';

    return (
      <CaptchaForm
        onResolved={ this.onResolved }
        name="loginform"
        className={ formClass }>

        <Field
          type="text"
          autoComplete="username"
          name="username"
          errorMessage={ dictionary.error.username }
          label={ dictionary.login.username }
          value={ this.getField('username').value }
          showError={ this.showError('username') }
          onChange={ this.onChange('username') }
          onBlur={ this.onBlur('username') }
          onFocus={ this.onFocus('username') }
          focusOnMount={ true }
          errorLines={ 2 }
        />

        <Field
          type="password"
          name="password"
          autoComplete="current-password"
          errorMessage={ dictionary.error.password }
          label={ dictionary.login.password }
          value={ this.getField('password').value }
          showError={ this.showError('password') }
          onChange={ this.onChange('password') }
          onBlur={ this.onBlur('password') }
          onFocus={ this.onFocus('password') }
        />

        { isProcessing &&
          <div className="login-processing" /> }

        <input type="submit"
          value={ dictionary.login.submit }
          className={ buttonClass }
          disabled={ !this.isEnabled } />
      </CaptchaForm>
    );
  }
}
